export default class ReportingAPIService {
  constructor($http, appSettings) {
    'ngInject';

    this.$http = $http;
    this.reportingUrl = appSettings.RepotingApiUrl;
    this.reportingEndpointUrl = `${appSettings.RepotingApiUrl}/reports`;
  }

  getReportsList() {
    const url = `${this.reportingEndpointUrl}`;
    return this.$http.get(url);
  }

  getReportById(reportId) {
    const url = `${this.reportingEndpointUrl}/${reportId}`;
    return this.$http.get(url);
  }

  refresh() {
    const url = `${this.reportingUrl}/refresh`;
    return this.$http.get(url);
  }
}
